import { create } from 'zustand';

export const useSessionConfigStore = create((set) => ({
  sessionData: [],
  totalElements: 0,
  loading: false,
  error: null,

  setSessionData: (data) => set({ sessionData: data }),
  setTotalElements: (total) => set({ totalElements: total }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),

  resetSessionData: () => set({ 
    sessionData: [], 
    totalElements: 0, 
    loading: false, 
    error: null 
  }),
}));
